import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "react-bootstrap";
import api from "../api/api";
import "../css/TherapistMilestones.css";

const clientMessages = [
	"You're showing up — that's what matters! 🌱",
	"Small steps still move you forward! 💪",
	"Every completed activity counts! ✔️",
	"Progress is built one session at a time! 📈",
	"Consistency beats perfection! ⭐",
	"You're building momentum! 🚀",
];

const ClientMilestones = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const fetchMilestones = async () => {
			try {
				const response = await api.get("/client-milestones/");
				setData(response.data);
			} catch (err) {
				console.error("Error fetching client milestones:", err);
				setError("Could not load milestones.");
			} finally {
				setLoading(false);
			}
		};

		fetchMilestones();
	}, []);

	if (loading) {
		return (
			<div className="therapist-milestones therapist-milestones-loading">
				<Spinner animation="border" size="sm" />
			</div>
		);
	}

	if (error) {
		return (
			<Alert variant="warning" className="mb-3">
				{error}
			</Alert>
		);
	}

	if (!data) {
		return null;
	}

	const weeklyExerciseCount = data.weekly.exercises_completed || 0;
	const weeklyExerciseLabel = weeklyExerciseCount === 1 ? "activity" : "activities";
	const message = clientMessages[data.message_index] || clientMessages[0];

	return (
		<div className="therapist-milestones client-milestones">
			<div className="milestone-hero">
				<div className="milestone-hero-copy">
					<div className="milestone-message">
						{message}
					</div>

					<div className="milestone-weekly">
						<span className="milestone-weekly-label">This week</span>
						<span>
							{weeklyExerciseCount} {weeklyExerciseLabel} completed
						</span>
					</div>
				</div>

			</div>
		</div>
	);
};

export default ClientMilestones;
